import { useState } from 'react';
import { Button } from '../../components/ui.tsx';

/** Read-only value with a copy-to-clipboard button (invite links, API secrets). */
export function CopyField({ value, label }: { value: string; label?: string }) {
  const [copied, setCopied] = useState(false);
  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard blocked — user can select manually */
    }
  }
  return (
    <div className="copy-field">
      <input aria-label={label ?? 'Copyable value'} value={value} readOnly onFocus={(e) => e.target.select()} />
      <Button size="sm" onClick={copy}>
        {copied ? 'Copied' : 'Copy'}
      </Button>
    </div>
  );
}
